<template>
  <moe-page>
    <moe-top ref="moeTop"></moe-top>
    <div class="content_box flex Flexjustify Flexalign">
      <div class="content flex">
        <div class="content_left">
          <!-- <div class="institution_info flex FlexBetween Flexalign">
            <div class="flex flexcolumn Flexalign learning_info">
              <div class="flex Flexalign learning_info_one">
                <el-image class="learning_time_icon" :src="iconPath('learning_time_icon.png')"></el-image>
                <div>今日学习时长(min)</div>
              </div>
              <div class="learning_time_value">
                {{ learningInfo.todayLearningTime }}
              </div>
              <div class="flex Flexalign Flexjustify learning_contrast">
                <div>比昨日</div>
                <div v-if="
                  learningInfo.todayLearningTime - learningInfo.yesterdayLearningTime ==
                  0
                ">
                  无变化
                </div>
                <div v-else class="mar_left_5" :class="[
                  learningInfo.todayLearningTime - learningInfo.yesterdayLearningTime <
                    0
                    ? 'contrast_add'
                    : 'contrast_reduce',
                ]">
                  {{
                    learningInfo.todayLearningTime - learningInfo.yesterdayLearningTime < 0 ? "-" : "+" }} </div>
                    <div :class="[
                      learningInfo.todayLearningTime - learningInfo.yesterdayLearningTime <
                        0
                        ? 'contrast_add'
                        : 'contrast_reduce',
                    ]">
                      {{
                        Math.abs(
                          learningInfo.todayLearningTime - learningInfo.yesterdayLearningTime
                        )
                      }}
                    </div>
                    <div v-if="
                      learningInfo.todayLearningTime - learningInfo.yesterdayLearningTime >
                      0
                    ">
                      <el-image class="rise_icon" :src="iconPath('rise_icon.png')"></el-image>
                    </div>
                    <div v-if="
                      learningInfo.todayLearningTime - learningInfo.yesterdayLearningTime <
                      0
                    ">
                      <el-image class="rise_icon" :src="iconPath('down_icon.png')"></el-image>
                    </div>
                </div>
              </div>
              <div class="flex flexcolumn Flexalign learning_info">
                <div class="flex Flexalign learning_info_one">
                  <el-image class="learning_time_icon" :src="iconPath('in_hand_icon.png')"></el-image>
                  <div>进行中课程</div>
                </div>
                <div class="learning_time_value">
                  {{ learningInfo.todayInHandCourse }}
                </div>
                <div class="flex Flexalign Flexjustify learning_contrast">
                  <div>比昨日</div>
                  <div v-if="
                    learningInfo.todayInHandCourse - learningInfo.yesterdayInHandCourse ==
                    0
                  ">
                    无变化
                  </div>
                  <div v-else class="mar_left_5" :class="[
                    learningInfo.todayInHandCourse - learningInfo.yesterdayInHandCourse <
                      0
                      ? 'contrast_add'
                      : 'contrast_reduce',
                  ]">
                    {{
                      learningInfo.todayInHandCourse - learningInfo.yesterdayInHandCourse < 0 ? "-" : "+" }} </div>
                      <div v-if="
                        learningInfo.todayInHandCourse - learningInfo.yesterdayInHandCourse !=
                        0
                      " :class="[
                        learningInfo.todayInHandCourse - learningInfo.yesterdayInHandCourse <
                          0
                          ? 'contrast_add'
                          : 'contrast_reduce',
                      ]">
                        {{
                          Math.abs(
                            learningInfo.todayInHandCourse - learningInfo.yesterdayInHandCourse
                          )
                        }}
                      </div>
                      <div v-if="
                        learningInfo.todayInHandCourse - learningInfo.yesterdayInHandCourse >
                        0
                      ">
                        <el-image class="rise_icon" :src="iconPath('rise_icon.png')"></el-image>
                      </div>
                      <div v-if="
                        learningInfo.todayInHandCourse - learningInfo.yesterdayInHandCourse <
                        0
                      ">
                        <el-image class="rise_icon" :src="iconPath('down_icon.png')"></el-image>
                      </div>
                  </div>
                </div>
                <div class="flex flexcolumn Flexalign learning_info">
                  <div class="flex Flexalign learning_info_one">
                    <el-image class="learning_time_icon" :src="iconPath('finish_icon.png')"></el-image>
                    <div>已完成课程</div>
                  </div>
                  <div class="learning_time_value">
                    {{ learningInfo.todayFinishCourse }}
                  </div>
                  <div class="flex Flexalign Flexjustify learning_contrast">
                    <div>比昨日</div>
                    <div v-if="
                      learningInfo.todayFinishCourse - learningInfo.yesterdayFinishCourse ==
                      0
                    ">
                      无变化
                    </div>
                    <div v-else class="mar_left_5" :class="[
                      learningInfo.todayFinishCourse - learningInfo.yesterdayFinishCourse <
                        0
                        ? 'contrast_add'
                        : 'contrast_reduce',
                    ]">
                      {{
                        learningInfo.todayFinishCourse - learningInfo.yesterdayFinishCourse < 0 ? "-" : "+" }} </div>
                        <div v-if="
                          learningInfo.todayFinishCourse - learningInfo.yesterdayFinishCourse >
                          0
                        ">
                          <el-image class="rise_icon" :src="iconPath('rise_icon.png')"></el-image>
                        </div>
                        <div v-if="
                          learningInfo.todayFinishCourse - learningInfo.yesterdayFinishCourse <
                          0
                        ">
                          <el-image class="rise_icon" :src="iconPath('down_icon.png')"></el-image>
                        </div>
                    </div>
                  </div>
                </div> -->

                <div class="lecturer_info">
                  <div class="menu_list flex">
                    <div class="menu_one flex flexcolumn Flexalign cursor_pointer" v-for="(item, index) in menuList"
                      :key="index" @click="chaneMenu(item)">
                      <div :class="[item.value == selectMenu ? 'active_text' : '']">
                        {{ item.label }}
                      </div>
                      <div :class="[item.value == selectMenu ? 'line_active' : '']"></div>
                    </div>
                  </div>
                  <div>
                    <mycourseList v-if="selectMenu == 0"></mycourseList>
                    <learningRecord v-else-if="selectMenu == 1"></learningRecord>
                    <learningNote v-else-if="selectMenu == 2"></learningNote>
                    <learningExam v-else-if="selectMenu == 3"></learningExam>
                    <wrongQuestion v-else-if="selectMenu == 4"></wrongQuestion>
                    <learningCertificate v-else-if="selectMenu == 5"></learningCertificate>
                    <homeworkList v-else-if="selectMenu == 6"></homeworkList>
                  </div>
                </div>
                <div class="course_list_box">
                  <div class="flex FlexBetween">
                    <div class="recommend">推荐课程</div>
                    <div class="more_btn flex Flexalign Flexjustify">
                      更多
                      <div class="flex Flexalign" style="margin-left: 5px">
                        <el-icon :size="18">
                          <ArrowRight color="rgba(102, 102, 102, 1)" />
                        </el-icon>
                      </div>
                    </div>
                  </div>
                  <courseList></courseList>
                </div>
              </div>
              <div class="content_right">
                <div class="top_banner_right flex flexcolumn">
                  <div class="flex FlexBetween">
                    <div class="recommend">公告</div>
                    <div class="more_btn flex Flexalign Flexjustify cursor_pointer" @click="goNotice">
                      更多
                      <div class="flex Flexalign" style="margin-left: 5px">
                        <el-icon :size="18">
                          <ArrowRight color="rgba(102, 102, 102, 1)" />
                        </el-icon>
                      </div>
                    </div>
                  </div>
                  <div class="notice_list">
                    <div class="notice_one flex Flexalign FlexBetween cursor_pointer"
                      v-for="(item, index) in noticeList" :key="index" @click="goNoticeDetail(item)"
                      @mouseenter="showHighColor(item)" @mouseleave="hideHighColor"
                      :class="[selectedNotice == item.noticeId ? 'high_notice_color' : '']">
                      <div class="notice_time">{{ item.createTime?.split(" ")[0] }}</div>
                      <div class="notice_title flex-1 toverflow">{{ item.noticeTitle }}</div>
                    </div>
                  </div>
                </div>
                <recommendCourseList></recommendCourseList>
              </div>
            </div>
          </div>
          <moe-bottom></moe-bottom>
          <moe-right :showCustomer="{ showCustomer: true }"></moe-right>
  </moe-page>
</template>
<script>
import courseList from "@/views/course/components/courseList.vue";
import mycourseList from "./components/mycourseList.vue";
import learningRecord from "./components/learningRecord.vue";
import learningNote from "./components/learningNote.vue";
import learningExam from "./components/learningExam.vue";
import learningCertificate from "./components/learningCertificate.vue";
import recommendCourseList from "@/views/course/components/recommendCourseList.vue";
import wrongQuestion from "./components/wrongQuestion.vue";
import homeworkList from "./components/homeworkList.vue";
export default {
  name: "GjkcH5Index",
  components: {
    courseList,
    mycourseList,
    learningRecord,
    learningNote,
    learningExam,
    learningCertificate,
    recommendCourseList,
    wrongQuestion,
    homeworkList,
  },
  data() {
    return {
      learningInfo: {
        todayLearningTime: 0,
        yesterdayLearningTime: 0,
        todayInHandCourse: 0,
        yesterdayInHandCourse: 0,
        todayFinishCourse: 0,
        yesterdayFinishCourse: 0,
      },
      menuList: [
        { label: "我的课程", value: 0 },
        { label: "学习记录", value: 1 },
        { label: "笔记", value: 2 },
        { label: "考试", value: 3 },
        // { label: "错题集", value: 4 },
        // { label: "证书", value: 5 },
        // { label: "作业", value: 6 },
      ],
      selectMenu: 0,
      rankList: [],
      noticeList: [],
      noticeListQuery: {
        courseId: "",
        page: 1,
        pageSize: 5,
      },
      selectedNotice: "",
      // finishCourseNum: 0, // 今日完成课程数
      // yesterdayFinishCourseNum: 0, // 昨日完成课程数
    };
  },

  mounted() {
    if (this.$Jump.getUrlParams(window.location.hash.split("?")[1]).selectMenu) {
      this.selectMenu = this.$Jump.getUrlParams(
        window.location.hash.split("?")[1]
      ).selectMenu;
    }
    this.topSelectedMenu = this.$Jump.getUrlParams(
      window.location.hash.split("?")[1]
    ).topSelectedMenu;
    this.$refs.moeTop.topSelectedMenu = this.topSelectedMenu;
    this.getNoticeList();
    // this.getStudyProgress(this.$Moment().format("YYYY-MM-DD HH:mm:ss"), "today");
    // this.getStudyProgress(
    //   this.$Moment().subtract(1, "days").format("YYYY-MM-DD HH:mm:ss"),
    //   "yesterday"
    // );
    // this.statisticsListForDay(this.$Moment().format("YYYY-MM-DD HH:mm:ss"), "today");
    // this.statisticsListForDay(
    //   this.$Moment().subtract(1, "days").format("YYYY-MM-DD HH:mm:ss"),
    //   "yesterday"
    // );
  },

  methods: {
    showHighColor(info) {
      this.selectedNotice = info.noticeId;
    },
    hideHighColor() {
      this.selectedNotice = "";
    },
    chaneMenu(info) {
      this.selectMenu = info.value;
    },
    goNotice() {
      this.href("/notice");
    },
    goNoticeDetail(info) {
      this.href("/noticeDetail", { noticeId: info.noticeId });
    },
    getNoticeList() {
      this.$Api.course
        .getCourseNoticeList(this.noticeListQuery)
        .then((res) => {
          this.noticeList = res.data.data.list;
        })
        .catch(() => { });
    },
    // 获取进行中/已完成课程统计
    getStudyProgress(date, type) {
      this.$Api.learning
        .getStudyProgress({ searchDate: date })
        .then((res) => {
          if (type == "today") {
            this.learningInfo.todayFinishCourse = res.data.data.finishNum;
            this.learningInfo.todayInHandCourse =
              res.data.data.totalNum - res.data.data.finishNum;
          } else if (type == "yesterday") {
            this.learningInfo.yesterdayFinishCourse = res.data.data.finishNum;
            this.learningInfo.yesterdayInHandCourse =
              res.data.data.totalNum - res.data.data.finishNum;
          }
        })
        .catch(() => { });
    },
    statisticsListForDay(date, type) {
      this.$Api.learning
        .statisticsListForDay({
          beginTime: date.split(" ")[0] + " 00:00:00",
          endTime: date.split(" ")[0] + " 23:59:59",
        })
        .then((res) => {
          if (type == "today") {
            this.learningInfo.todayLearningTime = this.$Tools.secondToMinute(
              res.data.data[0]?.totalSeconds
            );
          } else if (type == "yesterday") {
            this.learningInfo.yesterdayLearningTime = this.$Tools.secondToMinute(
              res.data.data[0]?.totalSeconds
            );
          }
        })
        .catch(() => { });
    },
  },
};
</script>
<style lang="scss" scoped>
.mar_top_20 {
  margin-top: 20px;
}

.mar_left_15 {
  margin-left: 15px;
}

.mar_left_20 {
  margin-left: 20px;
}

.mar_left_40 {
  margin-left: 40px;
}

.content_box {
  padding-top: 15px;
  width: 100%;
  background: #f3f3f3;

  .content {
    width: $pageMainWidth;

    .content_left {
      .institution_info {
        width: 848px;
        height: 134px;
        background: #ffffff;
        border-radius: 10px;
        padding: 15px 20px;
        box-sizing: border-box;

        .learning_info {
          font-size: 18px;
          color: #666666;

          .learning_info_one {
            .learning_time_icon {
              width: 18px;
              height: 18px;
              margin-right: 5px;
            }
          }

          .learning_time_value {
            font-weight: bold;
            font-size: 30px;
            color: #13d6aa;
            margin: 10px 0;
          }

          .learning_contrast {
            width: 97px;
            height: 25px;
            background: #fafafa;
            border-radius: 13px;
            font-size: 14px;
            color: #666666;
            line-height: 25px;
            text-align: center;

            .contrast_add {
              color: #13d6aa;
            }

            .contrast_reduce {
              color: RGBA(245, 54, 53, 1);
            }

            .rise_icon {
              width: 12px;
              height: 12px;
            }
          }
        }
      }

      .lecturer_info {
        width: 848px;
        background: #ffffff;
        border-radius: 10px;
        padding: 15px 20px;
        box-sizing: border-box;

        .menu_list {
          border-bottom: 1px solid rgba(20, 20, 20, 0.1);

          .menu_one {
            line-height: 50px;
            margin: 0 10px;
            position: relative;
          }

          .line_active {
            position: absolute;
            bottom: 0;
            width: 50px;
            height: 2px;
            background: #13d6aa;
          }

          .active_text {
            color: #13d6aa;
            font-weight: 600;
          }
        }
      }

      .course_list_box {
        margin: 20px 0;
        width: 100%;
        box-sizing: border-box;
        padding: 20px;
        background: #ffffff;
        border-radius: 10px;

        .recommend {
          font-weight: bold;
          font-size: 18px;
          color: #111111;
        }

        .more_btn {
          color: rgba(102, 102, 102, 1);
        }
      }
    }

    .content_right {
      margin-left: 20px;
      width: calc($pageMainWidth - 868px);

      .top_banner_right {
        width: 100%;
        box-sizing: border-box;
        background: rgba(255, 255, 255, 1);
        border-radius: 10px;
        padding: 12px;
        height: 300px;

        .notice_list {
          height: 260px;
          overflow: hidden;
        }

        .notice_one {
          color: #606060;
          // font-weight: 600;
          margin-top: 25px;

          .notice_title {
            margin-left: 20px;
            overflow: hidden;
            text-overflow: ellipsis;
            white-space: nowrap;
          }
        }

        .high_notice_color {
          color: #13d6aa;
        }
      }

      .recommend {
        font-weight: bold;
        font-size: 18px;
        color: #111111;
      }

      .more_btn {
        color: rgba(102, 102, 102, 1);
      }

      .course_list {
        margin-top: 10px;
        width: 100%;
        box-sizing: border-box;
        background: rgba(255, 255, 255, 1);
        border-radius: 10px;
        padding: 12px;

        .course_one {
          background: #ffffff;
          border-radius: 10px;
          width: 100%;
          margin-top: 15px;

          .course_title {
            font-weight: bold;
            font-size: 18px;
            color: #111111;
          }

          .course_rank_list {
            .course_one_img {
              width: 100px;
              height: 70px;
              border-radius: 10px;
            }

            .course_info {
              height: 70px;
              margin-left: 11px;

              .course_rate {
                :deep(.el-rate .el-rate__icon) {
                  margin-right: 0;
                }

                .course_price {
                  color: #ff6619;
                  font-size: 18px;
                  font-weight: 600;

                  .course_price_unit {
                    font-size: 16px;
                    font-weight: 400;
                  }
                }
              }

              .course_online_info {
                .course_online {
                  font-size: 14px;
                  color: #999999;
                }
              }
            }
          }
        }
      }
    }
  }
}
</style>
